import { useCallback, useEffect, useState } from "react";
import { gymClient } from "../apiClient/gymClient";
import type { Booking } from "../types/gym.types";

interface BookingsState {
  bookings: Booking[];
  isLoading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

/** The current user's confirmed bookings — drives the "already booked" state
 * on the calendar and the "your slots today" count. */
export function useBookings(): BookingsState {
  const [bookings, setBookings] = useState<Booking[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      setBookings(await gymClient.getBookings());
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load bookings.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { bookings, isLoading, error, refresh };
}
